const phoneRegex = /^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}$/;

export const validatePhone = (phone) => {
    return phoneRegex.test(phone);
}